import PartnerDeals from "../../features/partner-deals/PartnerDeals";

export default function PartnerDealsPage() {
  return (
    <div>
      <PartnerDeals />
    </div>
  );
}
